// extracted by mini-css-extract-plugin
module.exports = {"SquareOptions":"styles_SquareOptions__5u_a9"};